export const rows = [
  { sin: 'Horas planificando desde cero cada semana', con: 'Elige una clase estructurada y ajusta sus opciones a tu grupo.' },
  { sin: 'Sesiones improvisadas sin progresión real.', con: '51 clases estructuradas con tiempos, dosis y opciones de adaptación.' },
  { sin: 'Grupos sin sistema claro', con: 'Estructura clara para cada nivel.' },
  { sin: 'Siempre los mismos ejercicios', con: 'Regresiones y progresiones dentro de las fichas.' },
  { sin: 'Miedo a que una alumna se lesione', con: 'Protocolo de seguridad incluido' },
  { sin: 'Terminar cada clase agotada mentalmente', con: 'Llegas con todo resuelto' },
  { sin: 'Sin poder justificar un aumento de precio', con: 'Sistema documentado y profesional' },
  { sin: 'Dudas en cada corrección', con: 'Cues y frases exactas' }
];
